// extracted by mini-css-extract-plugin
export default {"linkList":"LinkList_linkList__bT2JH"};